import type { RouteRecordRaw } from 'vue-router';

import type { RouterConfig } from '@nuxt/schema';
import { asyncComponent } from '@nzyme/vue-utils/asyncComponent.js';
import { createComponentRoute, createLocalizedComponentRoute } from '@sigma/client/routes/createRoute.js';
import * as routes from '@sigma/patient-common/routes.js';

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default {
    routes: () => [...getRoutes()],
} satisfies RouterConfig;

function* getRoutes(): Generator<RouteRecordRaw> {
    yield createComponentRoute(routes.HomeRoute, {
        component: () => import('@/landing/LandingPage.vue'),
        auth: false,
    });

    yield* createLocalizedComponentRoute(routes.LandingRoute, {
        auth: false,
        component: () => import('@/landing/LandingPage.vue'),
    });

    yield* createLocalizedComponentRoute(routes.ChatsRoute, {
        auth: true,
        layout: 'app',
        component: () => import('@/main/pages/PatientMainPage.vue'),
    });

    yield* createLocalizedComponentRoute(routes.ChatRoute, {
        auth: true,
        layout: 'app',
        component: () => import('@/chat/ChatView.vue'),
    });

    yield* createLocalizedComponentRoute(routes.ChatStartRoute, {
        auth: true,
        layout: 'app',
        component: () => import('@/chat/ChatStartView.vue'),
    });

    yield* createLocalizedComponentRoute(routes.ProfileRoute, {
        auth: true,
        layout: 'app',
        component: () => import('@/profile/ProfilePage.vue'),
    });

    yield* createLocalizedComponentRoute(routes.LoginRoute, {
        auth: false,
        layout: 'app',
        component: () => import('@/auth/LoginPage.vue'),
    });

    yield* createLocalizedComponentRoute(routes.LogoutRoute, {
        auth: false,
        layout: 'login',
        component: () => import('@/auth/LogoutPage.vue'),
    });

    yield {
        path: '',
        component: asyncComponent(() => import('@/legal/LegalPage.vue')),
        children: [
            ...createLocalizedComponentRoute(routes.PrivacyPolicyRoute, {
                auth: false,
                component: {
                    pl: () => import('@/legal/content/PrivacyPolicy.pl.md'),
                    en: () => import('@/legal/content/PrivacyPolicy.en.md'),
                },
            }),
            ...createLocalizedComponentRoute(routes.TermsOfServiceRoute, {
                auth: false,
                component: {
                    pl: () => import('@/legal/content/TermsOfService.pl.md'),
                    en: () => import('@/legal/content/TermsOfService.en.md'),
                },
            }),
            ...createLocalizedComponentRoute(routes.AccessibilityStatementRoute, {
                auth: false,
                component: {
                    pl: () => import('@/legal/content/AccessibilityStatement.pl.md'),
                    en: () => import('@/legal/content/AccessibilityStatement.en.md'),
                },
            }),
            ...createLocalizedComponentRoute(routes.LegalNoticeRoute, {
                auth: false,
                component: {
                    pl: () => import('@/legal/content/LegalNotice.pl.md'),
                    en: () => import('@/legal/content/LegalNotice.en.md'),
                },
            }),
        ],
    };
}
